import { Typography, Badge } from "antd";
import { useState } from "react";
import {
  StyledIconItem,
  StyledMoreIcon,
  StyledNav,
  StyledNavIcon,
  StyledNavItem,
} from "./styled";
import { HeaderAvatar } from "../icons/HeaderAvatar";
import { BulkIcon } from "../icons/BulkIcon";
import { HeaderDivider } from "../icons/HeaderDivider";
import { NotificationIcon } from "../icons/NotificationIcon";
import { HeaderMessage } from "../icons/HeaderMessage";
import { HeaderMore } from "../icons/HeaderMore";

export const HeaderList = () => {
  const [headrItems, setHeaderItems] = useState([
    {
      key: "2.0",
      title: "",
      link: "",
    },
    {
      key: "2.1",
      title: "Задачи",
      link: "/tasks",
    },
    {
      key: "2.2",
      title: "Заявки НСИ",
      link: "/requisition",
    },
    {
      key: "2.3",
      title: "Аналитика",
      link: "/analytics",
    },
    {
      key: "2.4",
      title: "Стандарты",
      link: "/standards",
    },
    {
      key: "2.5",
      title: "Календарь",
      link: "/calendar",
    },
    {
      key: "2.6",
      title: "Поиск подрядчиков",
      link: "/contractor-search",
    },
  ]);

  const [headrIcons, setHeaderIcons] = useState([
    {
      key: "2.7",
      icon: (
        <Badge dot={true} offset={[-3, 4]}>
          <HeaderMessage />
        </Badge>
      ),
      link: "/messages",
    },
    {
      key: "2.8",
      icon: <HeaderDivider />,
      link: "",
    },
    {
      key: "2.9",
      icon: (
        <Badge dot={true} offset={[-6, 4]}>
          <NotificationIcon />
        </Badge>
      ),
      link: "/notifications",
    },
    {
      key: "2.10",
      icon: <HeaderDivider />,
      link: "",
    },
    {
      key: "2.11",
      icon: <BulkIcon />,
      link: "/bulk",
    },
    {
      key: "2.12",
      icon: <HeaderDivider />,
      link: "",
    },
    {
      key: "2.13",
      icon: <HeaderAvatar />,
      link: "/user",
    },
  ]);

  return (
    <StyledNav>
      {headrItems.map((item) => (
        <StyledNavItem key={item.key}>
          <Typography.Text>{item.title}</Typography.Text>
        </StyledNavItem>
      ))}

      <StyledMoreIcon>
        <HeaderMore />
      </StyledMoreIcon>

        {headrIcons.map((item) => (
          <StyledIconItem key={item.key}>
            <StyledNavIcon>{item.icon}</StyledNavIcon>
          </StyledIconItem>
        ))}
    </StyledNav>
  );
};
